module.exports = __webpack_public_path__ + "img/lentilles_moins_cheres.cab54f61.jpg";